module.exports = __webpack_public_path__ + "img/dot-blue.a625fd67.svg";